import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import PersetujuanLaparotomiSvc from "@/services/PersetujuanLaparotomi";

@Module({ store, dynamic: true, namespaced: true, name: "persetujuan-laparotomi" })
class PersetujuanLaparotomiModule extends VuexModule {
  items: any[] = [];
  currentItem: any = null;
  loading = false;
  masters: any = { risiko: [], komplikasi: [], alternatif: [], autofill: {} };

  @Mutation SET_ITEMS(val: any[]) {
    this.items = val;
  }

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_MASTERS(val: any) {
    this.masters = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);
    try {
      const dt = await PersetujuanLaparotomiSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_ITEMS(data || []);
    } catch {
      this.SET_ITEMS([]);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await PersetujuanLaparotomiSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadMasters() {
    if (this.masters.risiko && this.masters.risiko.length > 0) return;
    try {
      const dt = await PersetujuanLaparotomiSvc.getMasters();
      this.SET_MASTERS(dt.data.data || { risiko: [], komplikasi: [], alternatif: [], autofill: {} });
    } catch {
      this.SET_MASTERS({ risiko: [], komplikasi: [], alternatif: [], autofill: {} });
    }
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
  }
}

export const storePersetujuanLaparotomi = getModule(PersetujuanLaparotomiModule);
